import React, { useContext, ReactNode } from "react";
import { DialogContext, DialogProviderValue } from "components/Shared/DialogProvider.tsx";
import { MSpinner } from "components/Shared";

export interface PhoenixFormsDialogValue {
  show: (children: ReactNode) => void;
  showLoader: (title: string) => void;
  showError: (message: string) => void;
  hide: () => void;
  confirmDelete: (fileName: string, onYes: () => void) => void;
};

export const usePhoenixFormsDialog = (): PhoenixFormsDialogValue => {
  const dialog: DialogProviderValue = useContext(DialogContext);

  return {
    show: (children: ReactNode) => {
      dialog.show(null,
        children,
        [],
        {
          id: "phoenixform-v4-dialog",
          dontSpecifyWidth: true,
        }
      )
    },
    showLoader: (title: string) => {
      dialog.show(title, <MSpinner />, []);
    },
    showError: (message: string) => {
      dialog.show("Error", <div>{message}</div>, [{ label: "OK", isPrimary: false, onClick: () => { dialog.hide(); }}]);
    },
    hide: () => {
      dialog.hide();
    },
    confirmDelete: (fileName: string, onYes: () => void) => {
      dialog.showYesNo("Confirm", `Delete '${fileName}'?`,
        () => {
          onYes();
          dialog.hide();
          return true;
        },
        () => true
       );
    }
  };
};
